import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Bloqueja copiar, retallar, enganxar i el menú del botó dret.
 *
 * És a les dues pantalles de l'exercici —l'enunciat i la matriu— i **només per
 * a l'alumne**: l'instructor hi ha d'enganxar els relats i copiar-ne el text
 * per editar-lo, i bloquejar-l'hi seria trencar-li la feina.
 *
 * Què evita i què no: evita el gest fàcil —seleccionar el relat, copiar-lo i
 * enganxar-lo en una altra finestra—. **No és un pany**: qui vulgui pot fer una
 * captura, teclejar-ho a mà o obrir les eines del navegador. Serveix perquè
 * copiar deixi de ser el camí curt, no perquè sigui impossible.
 */
function BlocatgeCopia({ actiu = true }) {
  const { t } = useTranslation();
  const [avisObert, setAvisObert] = useState(false);

  useEffect(() => {
    if (!actiu) return undefined;

    const bloca = (e) => {
      e.preventDefault();
      setAvisObert(true);
    };

    // Escoltant els esdeveniments i no les tecles: així queden coberts també
    // el menú del botó dret, el menú «Edita» del navegador i el mòbil, que no
    // tenen cap Control ni cap Command pel mig.
    const noms = ['copy', 'cut', 'paste', 'contextmenu', 'dragstart'];
    noms.forEach((nom) => document.addEventListener(nom, bloca));
    return () => noms.forEach((nom) => document.removeEventListener(nom, bloca));
  }, [actiu]);

  if (!avisObert) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content modal-content--estret avis-temps" role="alertdialog" aria-modal="true">
        <div className="modal-body">
          <h3>{t('matrix.copyBlockedTitle')}</h3>
          <p>{t('matrix.copyBlockedBody')}</p>
          <div className="modal-accions">
            <button className="btn btn-primary" onClick={() => setAvisObert(false)} autoFocus>
              {t('common.accept')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlocatgeCopia;
